import { Button, Card, Typography, Form, Input, message } from "antd";
import React, { useState } from "react";
import { download } from "../../utils/http";

const { Title, Text } = Typography;

export default function VideoMultiAudio() {
  const [dialogName, setDialogName] = useState("");
  const [jsonData, setJsonData] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerate = async () => {
    if (!dialogName.trim()) {
      message.error("请填写对话名称");
      return;
    }

    if (!jsonData.trim()) {
      message.error("请输入JSON数据");
      return;
    }

    let data;
    try {
      data = JSON.parse(jsonData);
      if (!Array.isArray(data) || data.length === 0) {
        message.error("JSON数据必须是非空数组");
        return;
      }
    } catch (error) {
      message.error("JSON格式错误，请检查");
      return;
    }

    try {
      setIsGenerating(true);
      message.info("正在生成语音，请耐心等待...");

      const response = await download(
        "/api/manage/video-multi-audio",
        { data, name: dialogName },
        { timeout: 180000 },
      );

      const blob = response.data;
      const contentDisposition = response.headers["content-disposition"];
      let filename = "video_multi.zip";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (match) {
          filename = decodeURIComponent(match[1]);
        } else {
          const simpleMatch = contentDisposition.match(/filename="(.+)"/);
          if (simpleMatch) {
            filename = simpleMatch[1];
          }
        }
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      message.success("文件下载成功！");
    } catch (error) {
      console.error("生成失败:", error);
      message.error("生成失败，请重试");
    } finally {
      setIsGenerating(false);
    }
  };

  const handleReset = () => {
    setDialogName("");
    setJsonData("");
  };

  const jsonExample =
    '[{\n    "role": "TX3LPaxmHKxFdv7VOQHJ", // 男\n    "en": "English text",\n    "zh": "中文翻译"\n  },\n  {\n    "role": "Xb7hH8MSUJpSbSDYk0k2", // 女\n    "en": "English text",\n    "zh": "中文翻译"\n  }\n]';

  return (
    <div style={{ padding: 24, background: "#f5f5f5", minHeight: "100vh" }}>
      <Card
        title={
          <Title level={3} style={{ margin: 0 }}>
            视频多角色语音生成
          </Title>
        }
        extra={
          <>
            <Button onClick={handleReset} style={{ marginRight: 8 }}>
              重置
            </Button>
            <Button
              type="primary"
              onClick={handleGenerate}
              loading={isGenerating}
              disabled={isGenerating}
            >
              {isGenerating ? "生成中..." : "确定生成"}
            </Button>
          </>
        }
      >
        <div style={{ marginBottom: 16 }}>
          <Text type="secondary">
            请粘贴JSON格式的对话数据，系统将根据角色生成多角色语音，并生成中英文字幕文件，打包为ZIP下载。
          </Text>
        </div>

        <Form layout="vertical">
          <Form.Item label="对话名称">
            <Input
              value={dialogName}
              onChange={(e) => setDialogName(e.target.value)}
              placeholder="请输入本次对话的名称"
            />
          </Form.Item>

          <Form.Item label="JSON数据">
            <Input.TextArea
              value={jsonData}
              onChange={(e) => setJsonData(e.target.value)}
              placeholder="请粘贴JSON数据"
              rows={12}
              style={{ fontFamily: "monospace" }}
            />
          </Form.Item>

          <div
            style={{
              marginTop: 16,
              padding: 12,
              background: "#f5f5f5",
              borderRadius: 4,
            }}
          >
            <Text strong>JSON格式说明：</Text>
            <pre
              style={{
                marginTop: 8,
                marginBottom: 0,
                fontSize: 12,
                color: "#666",
              }}
            >
              {jsonExample}
            </pre>
          </div>
        </Form>
      </Card>
    </div>
  );
}
